// Components/RateTypeTable.jsx
import React from "react";
import { rateTypeColumns } from "./RateTypeData";
import DataTableHeader from "../../../../../../Common/DataTableHeader/DataTableHeader";
import DataTable from "../../../../../../Common/DataTable/DataTable";

const RateTypeTable = ({ data, loading, onEdit, onDelete }) => {
  const tableData = data.map((rt, index) => ({
    sno: index + 1,
    name: rt.name,
    room_type: rt.room_type?.name || "-",
    base_price: rt.base_price,
    is_active: rt.is_active ? (
      <span className="badge bg-success">Active</span>
    ) : (
      <span className="badge bg-secondary">Inactive</span>
    ),
    actions: (
      <>
        <button
          className="btn btn-sm btn-outline-primary me-2"
          onClick={() => onEdit(rt)}
        >
          <i className="bi bi-pencil-square"></i>
        </button>

        <button
          className="btn btn-sm btn-outline-danger"
          onClick={() => onDelete(rt.id)}
        >
          <i className="bi bi-trash"></i>
        </button>
      </>
    ),
  }));

  return (
    <>
      <DataTableHeader />
      {loading ? (
        <div className="py-4 text-center">
          <div className="spinner-border"></div>
        </div>
      ) : (
        <DataTable columns={rateTypeColumns} data={tableData} />
      )}
    </>
  );
};

export default RateTypeTable;
